import { isVersionUS } from "./versionService";
import { isProduction, isUKProduction, isUSProduction } from "./serviceConfig";

export const ISAMS_DEV_UK = "kihtest.parents.isamshosting.cloud";
export const ISAMS_PROD_UK = "kingsinterhigh.parents.isamshosting.cloud";

export const ISAMS_DEV_US = "uspa.parents.isams.cloud";
export const ISAMS_PROD_US = "kihusatest.parents.isams.cloud";

export const ISAMS_LINK = (() => {
    if (isVersionUS) {
        return isUSProduction ? ISAMS_PROD_US : ISAMS_DEV_US;
    }
    return isUKProduction ? ISAMS_PROD_UK : ISAMS_DEV_UK;
})();

export const SHOW_NEW_LINKS_PROD = true;
